export const employeeAccessOptions = [
  {
    label: "Generate Bill",
    value: "generateBill",
    children: [
      {
        label: "Bill Settings",
        value: "billSettings",
        children: [
          {
            label: "Other Charge",
            value: "otherCharges",
          },
          {
            label: "Add Discount",
            value: "discount",
          },
          {
            label: "Others",
            value: "otherAccess",
          },
          {
            label: "Coupon Discount",
            value: "couponDiscount",
          },
        ],
      },
      {
        label: "Add Item",
        value: "addItem",
      },
      {
        label: "Advance Settings",
        value: "advanceSettings",
      },

      {
        label: "Edit Pricing",
        value: "editPricing",
      },
      {
        label: "Hold bill",
        value: "holdBill",
      },
      {
        label: "Loyalty Redeem",
        value: "loyaltyRedeem",
      },
      {
        label: "Credit Sales",
        value: "creditSales",
      },
      {
        label: "Send Sms",
        value: "sendSms",
      },
      {
        label: "B2B pricing",
        value: "b2bPricingAccess",
      },
    ],
  },
  {
    label: "Dashboard",
    value: "dashboard",
    children: [
      {
        label: "Return Item",
        value: "returnItem",
      },
      {
        label: "Reprint",
        value: "reprint",
      },
    ],
  },
  {
    label: "Shop Item",
    value: "shopItem",
    children: [
      {
        label: "Products",
        value: "products",
        children: [
          {
            label: "Create Product",
            value: "createProduct",
          },
          {
            label: "Edit Product",
            value: "editProduct",
          },
          {
            label: "Delete Product",
            value: "deleteProduct",
          },
          {
            label: "Bulk Update price",
            value: "bulkUpdatePrice",
          },
        ],
      },
      {
        label: "Category",
        value: "category",
        children: [
          {
            label: "Create Category",
            value: "createCategory",
          },
          {
            label: "Edit Category",
            value: "editCategory",
          },
          {
            label: "Delete Category",
            value: "deleteCategory",
          },
        ],
      },
      {
        label: "Excel upload",
        value: "excelUpload",
      },
    ],
  },
  {
    label: "Tax Master",
    value: "taxMaster",
    children: [
      {
        label: "Custom Tax type",
        value: "customTaxType",
        children: [
          {
            label: "Create Custom Tax",
            value: "createCustomTax",
          },
          {
            label: "Edit Custom Tax",
            value: "editCustomTax",
          },
        ],
      },
      {
        label: "Create Tax",
        value: "createTax",
      },
      {
        label: "Edit Tax",
        value: "editTax",
      },
    ],
  },
  {
    label: "Reports",
    value: "reports",
    children: [
      {
        label: "Sales Report",
        value: "salesReport",
      },
      {
        label: "Profit and Loss",
        value: "profitAndLoss",
      },
      {
        label: "Stock Report",
        value: "stockReport",
      },
      {
        label: "Stock tracker",
        value: "stockTracker",
      },
    ],
  },
  {
    label: "Loyalty",
    value: "loyalty",
    children: [
      {
        label: "Reports",
        value: "loyaltyReport",
      },
      {
        label: "Add point",
        value: "addPoints",
      },
      {
        label: "Loyalty Configuration",
        value: "loyaltyConfiguration",
      },
    ],
  },
  {
    label: "Customer",
    value: "customer",
    children: [
      {
        label: "Outstanding",
        value: "outstanding",
      },
      {
        label: "Update Alias",
        value: "updateAlias",
      },
      {
        label: "View All Bills",
        value: "customerViewAllBills",
      },
    ],
  },
  {
    label: "Vendor",
    value: "vendor",
    children: [
      {
        label: "View Details",
        value: "viewDetails",
        children: [
          {
            label: "View Bill",
            value: "vendorViewDetails",
          },
          {
            label: "Cancel Bill",
            value: "cancelBill",
          },
        ],
      },
      {
        label: "Add bill",
        value: "addBill",
      },
      {
        label: "Create Vendor",
        value: "createVendor",
      },
      {
        label: "Edit Vendor",
        value: "editVendor",
      },
    ],
  },
  {
    label: "Expenses",
    value: "expense",
    children: [
      {
        label: "Create Expense",
        value: "createExpense",
      },
      {
        label: "Delete Expense",
        value: "deleteExpense",
      },
      {
        label: "Create Expense Type",
        value: "createExpenseType",
      },
      {
        label: "Edit Expense",
        value: "editExpense",
      },
    ],
  },
  {
    label: "Counter",
    value: "counter",
    children: [
      {
        label: "Expenses",
        value: "counterExpenses",
      },
      {
        label: "History",
        value: "counterHistory",
      },
    ],
  },
  {
    label: "Settings",
    value: "settings",
    children: [
      {
        label: "View Profile",
        value: "viewProfile",
      },
      {
        label: "Invoice Customization",
        value: "invoiceCustomization",
      },
      {
        label: "Barcode Printer",
        value: "barcodePrinter",
      },
    ],
  },
];

export const restaurantAccess = [
  {
    label: "Subscription",
    value: "subscription",
    children: [
      {
        label: "Edit Subscription",
        value: "editSubscription",
      },
      {
        label: "Create Subscription",
        value: "createSubscription",
      },
      {
        label: "Cancel Subscription",
        value: "cancelSubscription",
      },
      {
        label: "Delete Subscription",
        value: "deleteSubscription",
      },
    ],
  },
  {
    label: "Orders",
    value: "orders",
    children: [
      {
        label: "Active Order",
        value: "activeOrder",
      },
      {
        label: "Completed Order",
        value: "completedOrder",
      },
    ],
  },
];
